import { Activity } from "lucide-react";

import { Card, CardContent, CardHeader, CardTitle } from "@/common/ui/card";
import { Skeleton } from "@/common/ui/skeleton";

import type { WhoopCycle } from "../devices-types";

interface CyclesCardProps {
  cycles: WhoopCycle[];
  isLoading: boolean;
}

export function CyclesCard({ cycles, isLoading }: CyclesCardProps): React.ReactElement {
  return (
    <Card data-testid="cycles-card">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">Cycles</CardTitle>
        <Activity className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <Skeleton className="h-20 w-full" />
        ) : cycles.length > 0 ? (
          <div className="space-y-2">
            {cycles.map((cycle) => (
              <div
                key={cycle.id}
                data-testid={`cycle-${cycle.id}`}
                className="flex items-center justify-between rounded-md border p-2 text-sm"
              >
                <div>
                  <div className="font-medium">{new Date(cycle.start).toLocaleDateString()}</div>
                  <div className="text-xs text-muted-foreground">
                    {cycle.end ? "Complete" : "In progress"}
                  </div>
                </div>
                <div className="text-right">
                  <div className="font-medium">Strain: {cycle.score.strain.toFixed(1)}</div>
                  <div className="text-xs text-muted-foreground">
                    {Math.round(cycle.score.kilojoule / 4.184)} cal
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-muted-foreground">No cycle data available</p>
        )}
      </CardContent>
    </Card>
  );
}
